import MuiTableRow, { TableRowProps as MuiProps } from '@material-ui/core/TableRow';
import React, { FunctionComponent } from 'react';
import useStyles from './style';
import clsx from 'clsx';

type StyleProps = {
    striped?: boolean;
};

export interface TableRowProps extends StyleProps, MuiProps {}

const TableRow: FunctionComponent<TableRowProps> = (props: TableRowProps) => {
    const { striped, className, ...rest } = props;
    const classes = useStyles();
    const classNameMerged = clsx({ [classes.striped]: striped }, className);

    return <MuiTableRow className={classNameMerged} {...rest} />;
};

export default TableRow;
